import observ from 'observ';
import xtend from 'xtend';
import _ from 'underscore';

// only listen to socket msgs for our updates b/c of how the api works
export default function (api, socket) {
    var state = observ({ isResolving: false, data: {} });

    function handleUpdateOrAdd (data) {
        var newData = {};
        newData[data.data.assetID] = data.data;
        var oldData = state();
        state.set(xtend(oldData, { data: xtend(oldData.data, newData) }));
    }

    socket.assets(function onData (data) {
        if (data.action.type === 'delete') {
            var asset = state().data[data.data.assetID];
            var _state = state();
            if (asset.pendingDelete) {
                var newData = xtend(_state.data);
                delete newData[data.data.assetID];
                state.set(xtend(_state, { data: newData }));
                return;
            }

            var newData = xtend(_state.data);
            newData[data.data.assetID].pendingDelete = true;
            state.set(xtend(_state, { data: newData }));
        }

        if (
            data.action.type === 'add' ||
            data.action.type === 'update'
        ) {
            handleUpdateOrAdd(data);
        }
    });

    socket.thumbs(function onEvent (ev) {
        if (ev.type === 'add' && state().data[ev.data.assetID]) {
            handleUpdateOrAdd(ev);
        }
    });

    var parsedState = observ({ isResolving: false, data: [] });
    state(function onChange (data) {
        parsedState.set(xtend(data, { data: _.toArray(data.data) }));
    });

    return {
        state: parsedState,
        actions: {
            get: function (opts, cb) {
                state.set(xtend(state(), {
                    isResolving: true
                }));

                if (typeof opts === 'function') {
                    cb = opts;
                    opts = {};
                }

                cb = cb || function () {};

                // @XXX May need more testing
                // let action = (opts) ? 'get' : 'getMiscAssets';
                if (!opts) opts = {};

                api.getMiscAssets(opts, function (err, resp) {
                    if (err) {
                        state.set(xtend(state(), { isResolving: false }));
                        return cb(err);
                    }

                    if (resp.data) {
                        var d = resp.data.reduce(function (acc, d) {
                            acc[d.assetID] = d;
                            return acc;
                        }, {});
                    }

                    state.set({ isResolving: false, data: d || false });
                });
            },

            edit: api.edit,
            delete: api.delete
        }
    };
};
